import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import type { ChatMessage } from '@/types/chat'

export function MessageBubble({ message }: { message: ChatMessage }) {
  const mine = message.role === 'user'

  return (
    <div className={mine ? 'flex justify-end' : 'flex justify-start'}>
      <div
        className={
          mine
            ? 'max-w-[85%] rounded-card rounded-tr-sm bg-brand-600 px-3.5 py-2.5 text-white'
            : 'w-full rounded-card rounded-tl-sm border border-line bg-surface-2 px-3.5 py-2.5'
        }
      >
        {!mine && (
          <span className="mb-1 block text-[11px] font-medium text-brand-600">
            {message.streaming ? '查询中…' : '查询结果'}
          </span>
        )}
        {mine ? (
          <p className="whitespace-pre-wrap break-words text-sm leading-relaxed">
            {message.content}
          </p>
        ) : (
          <div className="md-body break-words text-sm leading-relaxed">
            <Markdown
              remarkPlugins={[remarkGfm]}
              components={{
                table: (props) => (
                  <div className="md-table-wrap">
                    <table {...props} />
                  </div>
                ),
              }}
            >
              {message.content || '正在检索设备台账…'}
            </Markdown>
            {message.streaming && message.content && (
              <span className="ml-1 inline-block h-3.5 w-1.5 translate-y-0.5 animate-pulse bg-brand-400" />
            )}
          </div>
        )}
      </div>
    </div>
  )
}
